import ReactDOM from 'react-dom';
import ownerDocument from 'dom-helpers/ownerDocument';
export default function (componentOrElement) {
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-overlay/src/utils/ownerDocument.js